import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { settingsAPI } from '../services/api'
import { toast } from 'react-hot-toast'

export const useSettings = () => {
  return useQuery({
    queryKey: ['admin', 'settings'],
    queryFn: async () => {
      const response = await settingsAPI.getSettings()
      return response.data.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  })
}

export const useUpdateSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (settings) => {
      const response = await settingsAPI.updateSettings(settings)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['admin', 'settings'])
      toast.success('Ayarlar basariyla kaydedildi')
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Ayarlar kaydedilemedi')
    },
  })
}

export const useSystemInfo = () => {
  return useQuery({
    queryKey: ['admin', 'system-info'],
    queryFn: async () => {
      const response = await settingsAPI.getSystemInfo()
      return response.data.data
    },
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
    retry: 1,
  })
}
